import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 tracking-tight group-hover:text-primary-600 transition-colors duration-200">
              {t('site.name')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link
              to="/category/shengli-yuanli"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              {t('nav.categories')}
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-6 py-4">
          <div className="flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link
              to="/category/shengli-yuanli"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {t('nav.categories')}
            </Link>
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}